/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { typography2 } from '@coursera/cds-core';

type Props = {
  label: string;
};

const styles = {
  // Override original styles to match Figma design
  tag: () => css`
    margin: 0 var(--cds-spacing-100);
    background-color: var(--cds-color-blue-900);
    color: var(--cds-color-white-0);
    border-radius: 4px;
    padding: 0 var(--cds-spacing-100);
    ${typography2.bodySecondary}
    font-weight: 900;
    text-decoration: none !important;
  `,
};

export const EntWebsiteNavTag = ({ label }: Props): React.ReactElement => {
  return <span css={styles.tag}>{label}</span>;
};

export default EntWebsiteNavTag;
